// extracted by mini-css-extract-plugin
export default {"Contact":"Contact_Contact__Gl70Q","heading":"Contact_heading__uhRIJ","top":"Contact_top__SsfkH","information":"Contact_information__2Q4Q+"};